const hazmat = [
  // ── HAZMAT DEFINITIONS AND PURPOSE ────────────────────────────────────────
  {
    id: "hm001",
    question: "What is a hazardous material (hazmat) as defined for transportation purposes?",
    options: [
      "Any liquid carried in a tank",
      "Any substance or material capable of posing an unreasonable risk to health, safety, or property when transported",
      "Only explosives and radioactive materials",
      "Any cargo weighing over 1,000 lbs",
    ],
    answer: 1,
    explanation: "The DOT defines a hazardous material as any substance or material that poses an unreasonable risk to health, safety, or property during transportation. This includes many classes of materials.",
  },
  {
    id: "hm002",
    question: "Who is responsible for deciding whether a shipment is classified as hazardous?",
    options: [
      "The driver",
      "The shipper",
      "The motor carrier",
      "The state DOT",
    ],
    answer: 1,
    explanation: "The shipper is responsible for properly identifying, classifying, packaging, labeling, and marking hazmat shipments. The driver's responsibility is to verify the paperwork and placards.",
  },
  {
    id: "hm003",
    question: "Which federal agency regulates the transportation of hazardous materials by highway?",
    options: [
      "EPA (Environmental Protection Agency)",
      "DOT/PHMSA (Pipeline and Hazardous Materials Safety Administration)",
      "OSHA",
      "FDA",
    ],
    answer: 1,
    explanation: "The DOT's Pipeline and Hazardous Materials Safety Administration (PHMSA) regulates hazmat transportation. FMCSA enforces the regulations for motor carriers.",
  },
  // ── HAZMAT CLASSES ─────────────────────────────────────────────────────────
  {
    id: "hm004",
    question: "How many hazmat classes are there under DOT regulations?",
    options: ["5", "7", "9", "12"],
    answer: 2,
    explanation: "There are 9 DOT hazmat classes. Some classes have divisions (sub-categories). Knowing the classes and their hazards is essential for safe handling.",
  },
  {
    id: "hm005",
    question: "Class 1 hazardous materials are:",
    options: [
      "Flammable liquids",
      "Explosives",
      "Radioactive materials",
      "Corrosives",
    ],
    answer: 1,
    explanation: "Class 1 is explosives. Divisions 1.1–1.6 describe the type and level of explosive hazard, from mass explosion (1.1) to very insensitive substances (1.6).",
  },
  {
    id: "hm006",
    question: "Class 2 hazardous materials are:",
    options: [
      "Flammable solids",
      "Gases (compressed, liquefied, or dissolved under pressure) — includes flammable, non-flammable, and toxic gases",
      "Oxidizers",
      "Radioactive materials",
    ],
    answer: 1,
    explanation: "Class 2 is gases. Division 2.1 = flammable gas, 2.2 = non-flammable/non-toxic gas, 2.3 = toxic gas. Examples: propane (2.1), nitrogen (2.2), chlorine (2.3).",
  },
  {
    id: "hm007",
    question: "Class 3 hazardous materials are:",
    options: [
      "Flammable liquids",
      "Flammable solids",
      "Oxidizers",
      "Corrosives",
    ],
    answer: 0,
    explanation: "Class 3 is flammable liquids — any liquid with a flash point below 141°F (60.5°C). Examples: gasoline, diesel fuel, ethanol.",
  },
  {
    id: "hm008",
    question: "Class 4 hazardous materials include:",
    options: [
      "Corrosives and oxidizers",
      "Flammable solids, spontaneously combustible materials, and dangerous-when-wet materials",
      "Radioactive materials",
      "Infectious substances",
    ],
    answer: 1,
    explanation: "Class 4 covers: 4.1 Flammable solids, 4.2 Spontaneously combustible, 4.3 Dangerous when wet (materials that emit flammable gas when in contact with water).",
  },
  {
    id: "hm009",
    question: "Class 5 hazardous materials are:",
    options: [
      "Toxic and infectious substances",
      "Oxidizers and organic peroxides",
      "Corrosive materials",
      "Miscellaneous hazardous materials",
    ],
    answer: 1,
    explanation: "Class 5 covers: 5.1 Oxidizers (materials that provide oxygen to support combustion) and 5.2 Organic peroxides (thermally unstable, may combust spontaneously).",
  },
  {
    id: "hm010",
    question: "Class 6 hazardous materials include:",
    options: [
      "Explosives",
      "Poisonous (toxic) materials and infectious substances",
      "Radioactive materials",
      "Corrosive materials",
    ],
    answer: 1,
    explanation: "Class 6 covers: 6.1 Toxic substances (poisons) and 6.2 Infectious substances (biological agents that can cause disease).",
  },
  {
    id: "hm011",
    question: "Class 7 hazardous materials are:",
    options: [
      "Corrosive materials",
      "Radioactive materials",
      "Organic peroxides",
      "Spontaneously combustible materials",
    ],
    answer: 1,
    explanation: "Class 7 is radioactive materials — any material containing radionuclides. Transport requires specific packaging, labeling, and sometimes routing restrictions.",
  },
  {
    id: "hm012",
    question: "Class 8 hazardous materials are:",
    options: [
      "Flammable gases",
      "Corrosives — materials that can damage or destroy metal and living tissue on contact",
      "Oxidizers",
      "Miscellaneous hazardous materials",
    ],
    answer: 1,
    explanation: "Class 8 is corrosives. Examples: battery acid (sulfuric acid), hydrochloric acid, sodium hydroxide (lye). They can cause severe burns to skin and damage metals.",
  },
  {
    id: "hm013",
    question: "Class 9 hazardous materials are:",
    options: [
      "Radioactive materials",
      "Miscellaneous hazardous materials not covered by Classes 1–8",
      "Explosives with minimal blast hazard",
      "Non-flammable gases",
    ],
    answer: 1,
    explanation: "Class 9 is miscellaneous hazardous materials — substances that present a hazard during transport but do not meet the criteria of other classes. Examples: dry ice, lithium batteries.",
  },
  // ── CDL HAZMAT ENDORSEMENT ──────────────────────────────────────────────────
  {
    id: "hm014",
    question: "A CDL Hazmat endorsement (H) is required when a driver transports:",
    options: [
      "Any cargo that is heavy or oversized",
      "A quantity of hazardous materials that requires placarding, or any quantity of a select agent or toxin",
      "Any liquid cargo",
      "Any cargo in a tank vehicle",
    ],
    answer: 1,
    explanation: "The H endorsement is required for drivers who transport placarded quantities of hazardous materials or any amount of certain especially dangerous materials.",
  },
  {
    id: "hm015",
    question: "To obtain a Hazmat endorsement, a driver must:",
    options: [
      "Only pass the written knowledge test",
      "Pass the written knowledge test AND pass a TSA security threat assessment (federal background check)",
      "Only pass a background check",
      "Take a 40-hour hazmat course",
    ],
    answer: 1,
    explanation: "Since 2005, obtaining or renewing an H endorsement requires both passing the written test and undergoing a TSA security threat assessment (federal background check).",
  },
  // ── SHIPPING PAPERS ────────────────────────────────────────────────────────
  {
    id: "hm016",
    question: "Shipping papers (hazmat manifest) must contain which four pieces of information for each hazmat item?",
    options: [
      "Weight, color, origin, destination",
      "Proper shipping name, hazard class, ID number (UN/NA), and packing group",
      "Shipper name, weight, value, and insurance",
      "Class, weight, carrier name, and truck number",
    ],
    answer: 1,
    explanation: "The four required elements are: (1) Proper shipping name, (2) Hazard class or division, (3) UN or NA identification number, and (4) Packing group (I, II, or III). Also required: total quantity.",
  },
  {
    id: "hm017",
    question: "Where must the driver keep hazmat shipping papers while driving?",
    options: [
      "In the glove box or any cab storage",
      "Within reach or clearly visible in a pouch on the driver's door, or on the seat when not driving",
      "In the sleeper berth",
      "Attached to the outside of the vehicle",
    ],
    answer: 1,
    explanation: "Shipping papers must be within reach while driving (in a door pouch or on the seat beside you), so emergency responders can find them quickly. When parked, place them on the seat or in the door pouch.",
  },
  {
    id: "hm018",
    question: "Why is it important to have correct shipping papers for hazmat loads?",
    options: [
      "For billing purposes only",
      "Emergency responders use them to identify the materials and determine how to respond to an accident",
      "Only required for crossing state lines",
      "Only required for Class 1 materials",
    ],
    answer: 1,
    explanation: "Shipping papers are the primary source of hazmat identification for first responders. Without them, responders cannot safely and effectively handle an accident involving hazmat.",
  },
  {
    id: "hm019",
    question: "What is an 'Emergency Response Guide' (ERG)?",
    options: [
      "A driver's manual for backing up",
      "A book used by emergency responders that provides guidance on initial response to hazmat incidents, including isolation distances and protective actions",
      "A map of hazmat routes",
      "A list of emergency phone numbers for carriers",
    ],
    answer: 1,
    explanation: "The ERG (published by PHMSA/Transport Canada) gives first responders immediate guidance on how to protect themselves and the public during a hazmat transportation incident.",
  },
  // ── PLACARDS ───────────────────────────────────────────────────────────────
  {
    id: "hm020",
    question: "Placards must be placed on how many sides of a vehicle carrying hazardous materials?",
    options: ["1 side (rear only)", "2 sides (front and rear)", "3 sides", "4 sides (front, rear, and both sides)"],
    answer: 3,
    explanation: "Federal regulations require placards on all four sides of the vehicle (or trailer) — front, rear, and both sides — so hazmat can be identified from any direction.",
  },
  {
    id: "hm021",
    question: "What is the minimum quantity of most hazmat before a vehicle must be placarded?",
    options: [
      "Any amount",
      "1,001 lbs (454 kg) or more",
      "5,000 lbs or more",
      "Only when the vehicle is full",
    ],
    answer: 1,
    explanation: "For most hazmat categories (Table 2 materials), placarding is required when the total weight of hazardous materials equals 1,001 lbs or more. Some Table 1 materials require placards in ANY amount.",
  },
  {
    id: "hm022",
    question: "Which materials require placarding in ANY amount (no minimum weight threshold)?",
    options: [
      "All Class 3 (flammable liquids)",
      "Table 1 materials: Explosives 1.1, 1.2, 1.3; Poison Gas (2.3); Dangerous When Wet (4.3); Poison Inhalation Hazard (6.1, Zone A or B); Radioactive (7)",
      "All Class 8 (corrosives)",
      "Only Class 1 (explosives)",
    ],
    answer: 1,
    explanation: "Table 1 materials must be placarded regardless of amount because they pose the highest risk. These include certain explosive, gas, radioactive, and inhalation-hazard materials.",
  },
  {
    id: "hm023",
    question: "What shape are hazmat placards?",
    options: [
      "Round",
      "Square turned on a point (diamond shape, at least 10¾ inches on each side)",
      "Rectangle",
      "Triangle",
    ],
    answer: 1,
    explanation: "DOT placards are diamond-shaped (square-on-point), at least 10¾ inches on each side, with specific colors and symbols for each hazard class.",
  },
  {
    id: "hm024",
    question: "What is a 'DANGEROUS' placard used for?",
    options: [
      "When the exact hazmat class is unknown",
      "When a vehicle carries 1,001 lbs or more of two or more different Table 2 hazardous materials that each require different placards",
      "For all loads with any hazmat",
      "Only for explosives",
    ],
    answer: 1,
    explanation: "The DANGEROUS placard may be used instead of separate placards when a vehicle carries 1,001–5,000 lbs of two or more different Table 2 hazmat categories. Over 5,000 lbs of any one requires its specific placard.",
  },
  // ── LABELS ──────────────────────────────────────────────────────────────────
  {
    id: "hm025",
    question: "Hazmat labels on packages are:",
    options: [
      "The same size as placards",
      "Smaller versions of placards placed on individual packages (at least 3.9 inches per side)",
      "Optional if the shipper provides documentation",
      "Only required for Class 1 materials",
    ],
    answer: 1,
    explanation: "Labels are smaller diamond-shaped markers (minimum 3.9 inches/side) affixed to individual packages to identify the hazard class. They are required by the shipper, not the carrier.",
  },
  // ── MARKINGS ───────────────────────────────────────────────────────────────
  {
    id: "hm026",
    question: "A four-digit ID number on an orange panel or placard identifies:",
    options: [
      "The shipping company's truck number",
      "The specific hazardous material (UN/NA identification number used by emergency responders to look up the material in the ERG)",
      "The driver's license number",
      "The weight of the hazmat load",
    ],
    answer: 1,
    explanation: "The UN/NA four-digit number identifies the specific material. Emergency responders use this number with the ERG to quickly find handling guidance for any hazmat.",
  },
  {
    id: "hm027",
    question: "What does 'RQ' on a hazmat shipping paper mean?",
    options: [
      "Required Quantity",
      "Reportable Quantity — the shipper must report a release of this material to the National Response Center",
      "Radioactive Quality",
      "Route Question",
    ],
    answer: 1,
    explanation: "RQ stands for Reportable Quantity. If the material is released in the listed quantity or more, it must be reported to the National Response Center (NRC) at 1-800-424-8802.",
  },
  // ── DRIVER RESPONSIBILITIES ─────────────────────────────────────────────────
  {
    id: "hm028",
    question: "Before transporting hazmat, a driver must check that:",
    options: [
      "Only the placards are correct",
      "The shipping papers match the load, placards are correct and properly displayed, and the vehicle is safe and legal for the hazmat being carried",
      "Only that the cargo is properly secured",
      "Only that the destination is hazmat-approved",
    ],
    answer: 1,
    explanation: "The driver must verify shipping paper accuracy, proper placarding, vehicle condition, and that all regulatory requirements for the specific hazmat are met before departure.",
  },
  {
    id: "hm029",
    question: "A driver should REFUSE a hazmat load if:",
    options: [
      "The load is very heavy",
      "The shipping papers are missing or incorrect, packages are damaged or leaking, or the vehicle is not properly placarded",
      "The destination is far away",
      "The load is being transported at night",
    ],
    answer: 1,
    explanation: "Never accept a hazmat load if documentation is incorrect, packages show damage or leakage, or the vehicle is not properly set up. Accepting an illegal load makes the carrier liable.",
  },
  {
    id: "hm030",
    question: "When fueling a vehicle with hazmat on board, you must:",
    options: [
      "Turn off the engine only if carrying Class 1 materials",
      "Turn off the engine, have someone at the nozzle at all times, and not leave the vehicle unattended",
      "Only have the engine off if carrying flammables",
      "Fuel normally — hazmat has no effect on fueling procedures",
    ],
    answer: 1,
    explanation: "When fueling with hazmat, keep the engine off, have someone at the fuel nozzle throughout fueling, and do not leave the vehicle unattended. Additional precautions may apply for specific materials.",
  },
  // ── SEGREGATION AND COMPATIBILITY ──────────────────────────────────────────
  {
    id: "hm031",
    question: "Which hazmat materials must NEVER be loaded together in the same vehicle?",
    options: [
      "Any two different hazmat classes",
      "Incompatible materials — for example, explosives with detonators (unless properly packed), chlorine with ammonia, oxidizers with flammables",
      "Two different packing groups",
      "Any hazmat with non-hazmat cargo",
    ],
    answer: 1,
    explanation: "The HMR lists incompatible materials that must not be loaded together because they could react violently. Always check the compatibility chart before loading mixed hazmat.",
  },
  {
    id: "hm032",
    question: "Explosives must NEVER be transported with which of the following?",
    options: [
      "Non-hazmat freight",
      "Blasting caps or detonators (unless properly packaged together per regulations), corrosives, flammables, or other incompatible materials",
      "Class 9 miscellaneous materials",
      "Oxidizers in packing group III",
    ],
    answer: 1,
    explanation: "Explosives have strict segregation requirements. Many materials can trigger detonation or cause fire. Explosives Class 1.1/1.2/1.3 have particularly strict separation requirements.",
  },
  {
    id: "hm033",
    question: "Hazmat packages labeled 'POISON' or 'POISON INHALATION HAZARD' must not be loaded with:",
    options: [
      "Class 9 materials",
      "Foodstuffs, feed, or any edible materials intended for human or animal consumption",
      "Non-hazmat dry goods",
      "Oxidizers in packing group III",
    ],
    answer: 1,
    explanation: "Poisons must be kept away from any food items, animal feed, or medicines intended for consumption. Contamination from even small amounts of many toxins can be fatal.",
  },
  // ── HAZMAT ROUTES AND RESTRICTIONS ─────────────────────────────────────────
  {
    id: "hm034",
    question: "Before transporting hazmat through a tunnel, you should:",
    options: [
      "Always proceed — tunnels have no restrictions",
      "Check with local authorities or your dispatcher — many tunnels prohibit or restrict certain hazmat classes",
      "Proceed only if the hazmat is in packing group III",
      "Proceed only at night",
    ],
    answer: 1,
    explanation: "Many tunnels ban or restrict hazmat vehicles. Always check tunnel rules before approaching. Some tunnels are completely closed to hazmat; others allow only certain classes.",
  },
  {
    id: "hm035",
    question: "Drivers transporting certain hazmat must use designated routes. What types of materials most commonly trigger routing restrictions?",
    options: [
      "Class 9 miscellaneous materials",
      "Highway route controlled quantities of radioactive materials, and certain hazmat in urban areas (HM-232 designated materials)",
      "All Class 3 flammable liquids",
      "Any material in packing group I",
    ],
    answer: 1,
    explanation: "High-level radioactive materials (highway route controlled quantities) must use federally designated routes. Some states also restrict certain hazmat from urban areas.",
  },
  {
    id: "hm036",
    question: "A driver transporting hazardous materials must not park within _____ feet of a bridge, tunnel, or building unless necessary for operations and the vehicle is attended.",
    options: ["100 feet", "300 feet", "500 feet", "1,000 feet"],
    answer: 1,
    explanation: "Hazmat vehicles must not park within 300 feet of a bridge, tunnel, or building unless necessary for operations. The vehicle must be attended when near these structures.",
  },
  // ── ATTENDING AND PARKING HAZMAT VEHICLES ──────────────────────────────────
  {
    id: "hm037",
    question: "A hazmat vehicle must be 'attended' at all times unless parked in certain safe areas. What does 'attended' mean?",
    options: [
      "The engine is running",
      "The driver is awake and within 100 feet of the vehicle and has an unobstructed view of it",
      "Someone is inside the vehicle",
      "The vehicle is locked",
    ],
    answer: 1,
    explanation: "A vehicle is attended when the driver (or responsible person) is awake, within 100 feet, and has a clear view of the vehicle. Sleeping in the cab does not qualify as attending.",
  },
  {
    id: "hm038",
    question: "Where may a driver NEVER park a hazmat vehicle?",
    options: [
      "In a truck stop parking lot",
      "Within 5 feet of a traveled roadway, near open fires, or in areas where the public may be endangered",
      "On a public street",
      "In a rest area",
    ],
    answer: 1,
    explanation: "Hazmat vehicles must not be parked within 5 feet of any traveled part of a road, near open fires, or anywhere that jeopardizes public safety. Specific materials have additional restrictions.",
  },
  // ── HAZMAT EMERGENCIES ──────────────────────────────────────────────────────
  {
    id: "hm039",
    question: "If hazardous materials are leaking or spilling from your vehicle, you should FIRST:",
    options: [
      "Try to contain the spill yourself",
      "Keep people away from the area, stay upwind, do not touch the material, and call 911 and the National Response Center (1-800-424-8802)",
      "Continue driving to reach a hospital",
      "Use your fire extinguisher on all leaks",
    ],
    answer: 1,
    explanation: "Your priority is to keep others away and call for help. Do not try to handle hazmat without proper training and equipment. Stay upwind and away from vapors.",
  },
  {
    id: "hm040",
    question: "The National Response Center (NRC) number to report hazmat spills is:",
    options: [
      "1-800-555-0000",
      "1-800-424-8802",
      "911 only",
      "1-888-DOT-SAFE",
    ],
    answer: 1,
    explanation: "The NRC (1-800-424-8802) is the 24-hour federal hotline for reporting hazmat incidents. You must call when a reportable quantity of a listed material is released.",
  },
  {
    id: "hm041",
    question: "If you discover a hazmat leak while driving, you should:",
    options: [
      "Pull over and investigate the leak yourself",
      "Move the vehicle away from populated areas only if it is safer to move, then get help",
      "Continue to the destination — a small leak is not dangerous",
      "Open all vents to dissipate fumes",
    ],
    answer: 1,
    explanation: "If safe to do so, move the vehicle to a safer location away from people, structures, and ignition sources. Then secure the vehicle, keep people away, and call for help.",
  },
  {
    id: "hm042",
    question: "You are involved in a hazmat accident. Besides notifying local authorities, you must also report to the carrier and National Response Center if:",
    options: [
      "Any hazmat is on board at all",
      "A person is killed, injured, or evacuated; a road is closed; or a reportable quantity of material is released",
      "The vehicle is damaged in any way",
      "Only if the material is radioactive",
    ],
    answer: 1,
    explanation: "A hazmat incident requiring NRC notification includes: death, injury, evacuation, road closure, or release of a reportable quantity. These are federal reporting requirements.",
  },
  // ── HAZMAT LOADING AND UNLOADING ────────────────────────────────────────────
  {
    id: "hm043",
    question: "When loading or unloading hazmat, the engine should be:",
    options: [
      "Running — in case you need to move quickly",
      "Turned off, unless engine power is needed for the loading/unloading operation (e.g., a pump)",
      "Left running only for flammable materials",
      "Running at low idle at all times",
    ],
    answer: 1,
    explanation: "Turn off the engine when loading or unloading hazmat, unless the engine is needed to power a pump or other equipment for the operation.",
  },
  {
    id: "hm044",
    question: "Before loading or unloading a hazmat shipment, you should ensure:",
    options: [
      "Only that the cargo door is open",
      "That the area is clear of hazards, proper equipment is available, you understand the material's hazards, and all safety measures are in place",
      "Only that the hazmat is properly labeled",
      "Only that the shipping papers are correct",
    ],
    answer: 1,
    explanation: "Pre-loading/unloading checks include: safe area, correct PPE available, understanding the material, no incompatible materials nearby, and proper handling equipment ready.",
  },
  // ── PACKING GROUPS ──────────────────────────────────────────────────────────
  {
    id: "hm045",
    question: "What do hazmat packing groups indicate?",
    options: [
      "The number of containers in a shipment",
      "The degree of danger — Packing Group I = greatest hazard, Packing Group II = medium hazard, Packing Group III = minor hazard",
      "The maximum allowable shipping quantity",
      "The type of container required",
    ],
    answer: 1,
    explanation: "Packing groups (PG I, II, III) indicate relative hazard. PG I materials are most dangerous and have the strictest packaging requirements; PG III materials are least dangerous.",
  },
  // ── POISON INHALATION HAZARD ────────────────────────────────────────────────
  {
    id: "hm046",
    question: "What is a 'Poison Inhalation Hazard' (PIH) or 'Toxic Inhalation Hazard' (TIH) material?",
    options: [
      "Any toxic material in Class 6",
      "A gas or liquid so toxic by inhalation that it poses a special danger even in small amounts — requires extra precautions including route planning",
      "Any material that smells bad",
      "Only radioactive gases",
    ],
    answer: 1,
    explanation: "PIH/TIH materials are extremely dangerous by inhalation. Examples: chlorine, anhydrous ammonia, hydrogen cyanide. They require specific emergency response zones and special handling.",
  },
  // ── FORBIDDEN MATERIALS ─────────────────────────────────────────────────────
  {
    id: "hm047",
    question: "Which of the following is ABSOLUTELY FORBIDDEN to transport by highway?",
    options: [
      "Class 3 flammable liquids in approved containers",
      "Forbidden materials such as certain unstable explosives, materials too dangerous to transport under any conditions",
      "Class 8 corrosives in packing group III",
      "Class 9 miscellaneous materials",
    ],
    answer: 1,
    explanation: "The HMR lists certain materials as 'Forbidden' — they may not be transported by any means of transportation. These are materials too unstable or dangerous to transport safely under any conditions.",
  },
  // ── BULK PACKAGING ──────────────────────────────────────────────────────────
  {
    id: "hm048",
    question: "A 'bulk package' for hazmat purposes is defined as a single container with a capacity of:",
    options: [
      "More than 1 gallon",
      "More than 119 gallons (liquids) or more than 882 lbs (solids) or more than 1,000 lbs water capacity for gases",
      "More than 55 gallons",
      "Any container requiring a forklift",
    ],
    answer: 1,
    explanation: "The HMR defines bulk packaging as: liquids > 119 gallons, solids > 882 lbs, gases > 1,000 lbs water capacity. Tank trucks and rail tank cars are examples of bulk packaging.",
  },
  // ── SPECIAL PERMITS AND EXEMPTIONS ─────────────────────────────────────────
  {
    id: "hm049",
    question: "A 'Special Permit' (formerly called 'exemption') for hazmat transport:",
    options: [
      "Is issued by state DMV",
      "Allows transport in ways that deviate from normal HMR requirements — issued by PHMSA — and must be carried in the vehicle",
      "Is required for all hazmat shipments",
      "Only applies to Class 1 materials",
    ],
    answer: 1,
    explanation: "PHMSA issues Special Permits allowing transport under conditions that differ from the standard rules. The permit number must appear on shipping papers and the permit itself must be in the vehicle.",
  },
  // ── HAZMAT TRAINING ─────────────────────────────────────────────────────────
  {
    id: "hm050",
    question: "How often must hazmat employees (including drivers) receive hazmat training?",
    options: [
      "Once, when first hired",
      "Within 90 days of employment and at least every 3 years thereafter",
      "Every year",
      "Only when regulations change",
    ],
    answer: 1,
    explanation: "HMR requires hazmat employee training within 90 days of employment, and recurrent training at least every 3 years. Training records must be kept for 3 years after the last training date.",
  },
  {
    id: "hm051",
    question: "Hazmat training for drivers must include which general areas?",
    options: [
      "Only how to identify the hazmat class",
      "General hazmat awareness, function-specific training, safety training, security awareness, and in-depth security training (if required)",
      "Only packaging and labeling",
      "Only emergency response procedures",
    ],
    answer: 1,
    explanation: "Required hazmat training covers: general awareness, function-specific (driver's specific job duties), safety, and security awareness (plus in-depth security if transporting certain materials).",
  },
  // ── HAZMAT SECURITY ─────────────────────────────────────────────────────────
  {
    id: "hm052",
    question: "Under the post-9/11 security rules, carriers transporting certain hazmat must have:",
    options: [
      "Only an extra fire extinguisher",
      "A written security plan that covers personnel security, unauthorized access prevention, and en-route security measures",
      "Armed security escorts at all times",
      "GPS tracking only",
    ],
    answer: 1,
    explanation: "Carriers transporting certain high-risk hazmat must have a written Hazmat Security Plan addressing employee security, access to vehicles, and measures during transport.",
  },
  {
    id: "hm053",
    question: "If you discover your hazmat vehicle has been tampered with:",
    options: [
      "Ignore it if the load appears intact",
      "Do not move the vehicle — contact law enforcement and your dispatcher immediately",
      "Check the cargo and continue if it looks fine",
      "Only report it if the tamper seal is broken",
    ],
    answer: 1,
    explanation: "Vehicle tampering is a serious security event. Do not move the vehicle. Notify law enforcement and your dispatcher immediately so the situation can be professionally assessed.",
  },
  // ── HAZMAT VEHICLE REQUIREMENTS ─────────────────────────────────────────────
  {
    id: "hm054",
    question: "What type of fire extinguisher is required on a hazmat vehicle?",
    options: [
      "Any fire extinguisher will do",
      "At minimum a 10 B:C rated extinguisher — specific requirements vary by material being transported",
      "A water-based extinguisher only",
      "No fire extinguisher is required — too dangerous to fight hazmat fires",
    ],
    answer: 1,
    explanation: "CMVs must carry a 10 B:C rated fire extinguisher at minimum. Some hazmat loads require larger extinguishers. Never fight a hazmat fire unless trained and equipped.",
  },
  {
    id: "hm055",
    question: "When transporting Division 1.1, 1.2, or 1.3 explosives, the driver must have a written route plan approved by:",
    options: [
      "The motor carrier only",
      "The shipper and the relevant state/local authorities — and the driver must follow it exactly",
      "Only the federal DOT",
      "No route plan is required for explosives",
    ],
    answer: 1,
    explanation: "Division 1.1, 1.2, 1.3 explosive shipments require pre-trip route authorization from state and local authorities along the route. The driver must carry and follow the written plan.",
  },
];

export default hazmat;
